"use client";

import React from "react";
import { MapPin, Phone, Clock, Navigation, CheckCircle } from "lucide-react";
export default function LocationMap() {
  return <section id="location" className="bg-gradient-to-b from-[#F7F9FC] to-white py-5 lg:py-8 border-t border-[#E3E7EF]">
      <div className="max-w-[1180px] mx-auto px-3 lg:px-8">
        
        <div className="text-center mb-4 lg:mb-6">
          <h2 className="text-[25px] lg:text-[42px] font-black italic uppercase leading-none">
            Visit <span className="text-[#0B4DBA]">Nova Tire Center</span>
          </h2>
          <p className="mt-1 lg:mt-2 text-[#5B6575] text-[12px] lg:text-[15px]">
            Easy access, fast same-day service, no appointment needed.
          </p>
        </div>

        <div className="relative overflow-hidden rounded-[16px] lg:rounded-[18px] border border-[#E3E7EF] shadow-[0_10px_22px_rgba(7,27,58,0.09)] lg:shadow-[0_12px_28px_rgba(7,27,58,0.10)] bg-white">
          <div className="grid grid-cols-1 lg:grid-cols-[0.4fr_0.6fr]">
            
            <div className="p-4 lg:p-6 bg-[#071B3A] text-white relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-[4px] bg-gradient-to-r from-[#FF5A00] via-[#0B4DBA] to-[#7DB2FF]" />

              <h3 className="text-[18px] lg:text-[22px] font-black italic uppercase leading-tight mb-3 lg:mb-4">
                How to find us
              </h3>

              <div className="space-y-2.5 lg:space-y-3">
                <div className="flex gap-2.5 lg:gap-3">
                  <MapPin className="w-4 h-4 lg:w-5 lg:h-5 text-[#7DB2FF] shrink-0 mt-1" />
                  <div>
                    <p className="font-black uppercase text-[11px] lg:text-xs">Address</p>
                    <p className="text-white/90 text-[13px] lg:text-sm">8635 W Pico Blvd</p>
                    <p className="text-white/90 text-[13px] lg:text-sm">Los Angeles, CA 90035</p>
                    <p className="text-[#FFB37A] font-bold text-[11px] lg:text-xs mt-1">
                      Entrance from the alley behind the building
                    </p>
                  </div>
                </div>

                <div className="flex gap-2.5 lg:gap-3">
                  <Clock className="w-4 h-4 lg:w-5 lg:h-5 text-[#7DB2FF] shrink-0 mt-1" />
                  <div>
                    <p className="font-black uppercase text-[11px] lg:text-xs">Hours</p>
                    <p className="text-white/90 text-[13px] lg:text-sm">Open 7 days</p>
                    <p className="text-white/75 text-[11px] lg:text-xs">
                      Mon–Fri: 8 AM–6 PM
                    </p>
                    <p className="text-white/75 text-[11px] lg:text-xs">
                      Sat–Sun: 9 AM–7 PM
                    </p>
                    <p className="hidden lg:block text-[#FFB37A] text-[11px] mt-1">
                      Hours may vary — check Google
                    </p>
                  </div>
                </div>

                <div className="flex gap-2.5 lg:gap-3">
                  <Phone className="w-4 h-4 lg:w-5 lg:h-5 text-[#7DB2FF] shrink-0 mt-1" />
                  <div>
                    <p className="font-black uppercase text-[11px] lg:text-xs">Phone</p>
                    <p className="text-white/90 text-[13px] lg:text-sm">(424) 313-8474</p>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap gap-2 mt-3 lg:mt-4">
                <a href="https://www.google.com/maps/dir/?api=1&destination=8635+W+Pico+Blvd+Los+Angeles+CA+90035" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-white text-[#0B4DBA] px-3 lg:px-4 py-2 rounded-md font-black uppercase text-[11px] lg:text-xs">
                  <Navigation className="w-4 h-4" />
                  Directions
                </a>

                <a href="tel:+14243138474" className="hidden lg:inline-flex items-center gap-2 bg-[#FF5A00] text-white px-4 py-2 rounded-md font-black uppercase text-xs">
                  <Phone className="w-4 h-4" />
                  Call
                </a>
              </div>

              <div className="hidden lg:grid mt-4 pt-3 border-t border-white/15 gap-1 text-xs text-white/85">
                <div className="flex items-center gap-2">
                  <CheckCircle className="w-3.5 h-3.5 text-[#7DB2FF]" />
                  Easy alley entrance
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle className="w-3.5 h-3.5 text-[#7DB2FF]" />
                  Same-day service
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle className="w-3.5 h-3.5 text-[#7DB2FF]" />
                  No appointment needed
                </div>
              </div>
            </div>

            <div className="relative min-h-[170px] lg:min-h-[280px]">
              <iframe src="https://www.google.com/maps?q=8635%20W%20Pico%20Blvd%20Los%20Angeles%20CA%2090035&output=embed" width="100%" height="100%" style={{
              border: 0
            }} loading="lazy" title="Nova Tire Center Map" className="absolute inset-0 w-full h-full grayscale-[10%] contrast-[1.05]" />
            </div>

          </div>
        </div>
      </div>
    </section>;
}